// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let PasswordSettings = require("./PasswordSettings.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let SettingsPageHeader = require("./SettingsPageHeader.bs.js");

function PasswordPage(props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(SettingsPageHeader.make, {
        title: "Password"
      }),
      JsxRuntime.jsx(PasswordSettings.make, {})
    ],
    className: "space-y-8 rounded bg-white p-6 shadow-sm"
  });
}

let make = PasswordPage;

exports.make = make;
/* PasswordSettings Not a pure module */
